import { Navigate } from 'react-router-dom';
import { useAuth, useConsentPending } from '@practium/features/auth';
import { UserRole } from '@practium/shared';
import { LoadingState } from '@practium/ui';

interface ProtectedRouteProps {
	children: React.ReactNode;
	allowedRoles?: UserRole[];
	allowAdmin?: boolean;
	allowPendingSubscription?: boolean;
}

export const ProtectedRoute = ({
	children,
	allowedRoles,
	allowAdmin = false,
	allowPendingSubscription = false,
}: ProtectedRouteProps) => {
	const { user, isLoading } = useAuth();
	const isConsentPending = useConsentPending();

	if (isLoading) {
		return <LoadingState fullScreen />;
	}

	if (!user) {
		return <Navigate to="/login" replace />;
	}

	if (allowedRoles && !isConsentPending) {
		const isAdmin = user.role === UserRole.Admin;
		const hasAllowedRole = !!user.role && allowedRoles.includes(user.role);
		const isPendingSubscription =
			allowPendingSubscription &&
			!user.role &&
			!user.isMaster &&
			user.subscription?.paymentStatus !== 'paid' &&
			allowedRoles.some(role => role !== UserRole.Admin);

		if (!hasAllowedRole && !isPendingSubscription && !(allowAdmin && isAdmin)) {
			return <Navigate to="/unauthorized" replace />;
		}
	}

	return <>{children}</>;
};
